export const normalizeVatIdInput = (value) =>
  String(value ?? "")
    .trim()
    .toUpperCase()
    .replace(/\s+/g, "");

export const getVatIdError = (value) => {
  const raw = normalizeVatIdInput(value);
  if (!raw) return "";

  const countryCode = raw.slice(0, 2);
  const ok =
    countryCode === "DE"
      ? /^DE\d{9}$/.test(raw)
      : /^[A-Z]{2}(?=.*\d)[A-Z0-9]{2,12}$/.test(raw);
  return ok ? "" : "Ungültige Umsatzsteuer-ID (z. B. DE123456789)";
};
